import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from 'react';

import { SingleIconButton } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import UploadFotosEntradaModal from './UploadFotosEntradaModal';
import UploadFotosSalidaModal from './UploadFotosSalidaModal';

export type FotosPendingCellOTInstallProps = {
  ordenTrabajo: OrdenTrabajo;

  isEntrada?: boolean;
  isSalida?: boolean;
};

const FotosPendingCellOTInstall: React.FC<FotosPendingCellOTInstallProps> = ({
  ordenTrabajo,
  isEntrada,
  isSalida,
}) => {
  ///* local state
  const [isOpenFotosEntradaModal, setIsOpenFotosEntradaModal] = useState(false);
  const [isOpenFotosSalidaModal, setIsOpenFotosSalidaModal] = useState(false);

  return (
    <>
      {isEntrada && (
        <SingleIconButton
          startIcon={<CloudUploadIcon />}
          color="info"
          label={'Cargar Fotos Entrada'}
          onClick={() => {
            setIsOpenFotosEntradaModal(true);
          }}
        />
      )}

      {isSalida && (
        <SingleIconButton
          startIcon={<CloudUploadIcon />}
          color="primary"
          label={'Cargar Fotos Salida'}
          onClick={() => {
            setIsOpenFotosSalidaModal(true);
          }}
        />
      )}

      {/* ========= modals ========= */}
      <UploadFotosEntradaModal
        ordenTrabajo={ordenTrabajo}
        open={isOpenFotosEntradaModal && !!isEntrada}
        onClose={() => {
          setIsOpenFotosEntradaModal(false);
        }}
      />

      <UploadFotosSalidaModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosSalidaModal && !!isSalida}
        onClose={() => {
          setIsOpenFotosSalidaModal(false);
        }}
      />
    </>
  );
};

export default FotosPendingCellOTInstall;
